import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { cn } from '../../lib/utils';

const destinations = [
  {
    name: 'Maldives',
    image: 'https://images.pexels.com/photos/1320684/pexels-photo-1320684.jpeg?auto=compress&cs=tinysrgb&w=800',
    packages: '12 Packages',
    category: 'Honeymoon',
    size: 'large'
  },
  {
    name: 'Switzerland',
    image: 'https://images.pexels.com/photos/2363/france-landmark-lights-night.jpg?auto=compress&cs=tinysrgb&w=800',
    packages: '15 Packages',
    category: 'International',
    size: 'small'
  },
  {
    name: 'Bali',
    image: 'https://images.pexels.com/photos/2166559/pexels-photo-2166559.jpeg?auto=compress&cs=tinysrgb&w=800',
    packages: '8 Packages',
    category: 'International',
    size: 'small'
  },
  {
    name: 'Kerala',
    image: 'https://images.pexels.com/photos/962464/pexels-photo-962464.jpeg?auto=compress&cs=tinysrgb&w=800',
    packages: '20 Packages',
    category: 'Domestic',
    size: 'medium'
  },
  {
    name: 'Dubai',
    image: 'https://images.pexels.com/photos/1534411/pexels-photo-1534411.jpeg?auto=compress&cs=tinysrgb&w=800',
    packages: '10 Packages',
    category: 'International',
    size: 'medium'
  }
];

export function PopularDestinations() {
  return (
    <section className="py-20 bg-[#004E64]" data-testid="popular-destinations">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-[#FF6B35] text-sm font-semibold tracking-wider uppercase mb-3">
            🌍 Explore The World
          </span>
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Popular Destinations
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-lg">
            Discover our most loved destinations and start planning your next adventure.
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[200px]">
          {destinations.map((dest, index) => (
            <Link
              key={dest.name}
              to={`/tours?destination=${dest.name}`}
              className={cn(
                'group relative rounded-2xl overflow-hidden cursor-pointer',
                dest.size === 'large' && 'col-span-2 row-span-2',
                dest.size === 'medium' && 'col-span-2 md:col-span-1 row-span-1',
                dest.size === 'small' && 'col-span-1 row-span-1'
              )}
              data-testid={`destination-${dest.name.toLowerCase()}`}
            >
              {/* Image */}
              <img
                src={dest.image}
                alt={dest.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

              {/* Category Badge */}
              <div className="absolute top-4 left-4">
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full">
                  {dest.category}
                </span>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 
                  className="text-xl md:text-2xl font-bold text-white mb-1 group-hover:text-[#FF6B35] transition-colors"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {dest.name}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-white/70 text-sm">{dest.packages}</span>
                  <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1 text-sm">
                    Explore <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
